<script setup>
import { onMounted, ref, inject } from "vue";
import { useForm } from "@inertiajs/vue3";
import { useJabatanStore } from "@/stores/jabatan";
import Swal from "sweetalert2";
const route = inject('route');
// import { route } from "ziggy-js";

const jabatanStore = useJabatanStore();

const form = useForm({
  id: null,
  namajabatan: "",
});

const isEdit = ref(false);

const submit = () => {
  const method = form.id ? "put" : "post";
  const routeName = form.id ? "jabatan.update" : "jabatan.store";

  form[method](route(routeName, form.id || {}), {
    onSuccess: () => {
      Swal.fire(
        "Berhasil",
        `Jabatan ${form.id ? "diperbarui" : "ditambahkan"}`,
        "success"
      );
      form.reset();
      isEdit.value = false;
      jabatanStore.fetchAll();
    },
    onError: () => {
      Swal.fire("Gagal", "Terjadi kesalahan saat menyimpan data", "error");
    },
  });
};

const edit = (jabatan) => {
  form.id = jabatan.id;
  form.namajabatan = jabatan.namajabatan;
  isEdit.value = true;
};

const remove = async (id) => {
  const confirm = await Swal.fire({
    title: "Hapus?",
    text: "Data akan dihapus permanen.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, hapus",
  });

  if (confirm.isConfirmed) {
    await jabatanStore.remove(id);
    Swal.fire("Terhapus", "Data berhasil dihapus", "success");
  }
};

onMounted(() => {
  jabatanStore.fetchAll();
});
</script>

<template>
  <div>
    <h1 class="mb-4 text-xl font-bold">Data Jabatan</h1>

    <form @submit.prevent="submit" class="mb-6 space-y-4">
      <input
        v-model="form.namajabatan"
        placeholder="Nama Jabatan"
        class="w-full p-2 border"
      />
      <button type="submit" class="btn btn-primary">
        {{ isEdit ? "Update" : "Simpan" }}
      </button>
    </form>

    <ul>
      <li
        v-for="jabatan in jabatanStore.list"
        :key="jabatan.id"
        class="flex justify-between"
      >
        <span>{{ jabatan.namajabatan }}</span>
        <div>
          <button @click="edit(jabatan)" class="text-blue-500">Edit</button>
          <button @click="remove(jabatan.id)" class="ml-2 text-red-500">
            Hapus
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>
